// Global Instructions Rule Applied!
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFile, faLink } from '@fortawesome/free-solid-svg-icons'
import { URL_TYPE } from '../../../../state_manager/constants/files.ts'

interface FileIconProps {
  type: typeof URL_TYPE | 'file'
}

const FileIcon = ({ type }: FileIconProps) => {
  return (
    <FontAwesomeIcon
      icon={type === URL_TYPE ? faLink : faFile}
      className={type === URL_TYPE ? 'text-blue-500' : 'text-green-500'}
    />
  )
}

export default FileIcon
